import { palette } from '../global/palette';

export const MuiSwitch = {
  MuiSwitch: {
    styleOverrides: {
      root: {
        width: 32,
        height: 18,
        padding: 0,
        margin: '8px 12px 8px 0',
      },
      switchBase: {
        padding: 0,
        margin: 2,
        transitionDuration: '300ms',
        '&.Mui-checked': {
          transform: 'translateX(14px)',
          color: palette.common.white,
          '&.Mui-disabled': {
            color: palette.common.white,
          },
          '& + .MuiSwitch-track': {
            opacity: 1,
            border: 0,
          },
        },
        '&.Mui-disabled + .MuiSwitch-track': {
          backgroundColor: palette.grey[400],
          opacity: 1,
        },
      },
      thumb: {
        width: 14,
        height: 14,
      },
      track: {
        borderRadius: 45,
        backgroundColor: palette.grey[500],
        opacity: 1,
      },
    },
  },
};
